import { qty } from './picklistProgress';

/**
 * PT-6 C4's row checks, mirroring CSC_CORE `AdjustCaps`. The vitest vectors (`adjustCaps.test.ts`) repeat
 * `AdjustCapsTests` verbatim, so the dialog and the server answer the same input with the same sentence.
 *
 * A row only goes down (owner 2026-10-05; the server too since F-02, 2026-10-06). Counting more for a line is a Move.
 * The 09-25 balance and its cap are gone. A line picked past its plan by legacy data shows no error until changed.
 */

export interface AdjustRowCheck {
  /** The row's picked units now. */
  current: number;
  /** Its posted floor. */
  posted: number;
  /** The typed figure, else `current`. */
  value: number;
  /** The item is planned for two or more MRS lines on this picklist, so a Move can count more for this one. */
  itemHasSeveralLines: boolean;
  unit: string;
}

/**
 * C4's row checks, the first that applies, or null. The dialog checks a box that holds no number first ("Enter a
 * quantity."); the server never sees one.
 */
export function adjustRowError(row: AdjustRowCheck): string | null {
  // ISS-R-011 — a row never rises.
  if (row.value > row.current) {
    return `Only ${qty(row.current)} ${row.unit} `
      + (row.itemHasSeveralLines ? 'are counted for this line here' : 'were picked here')
      + ' — it can only go down.'
      + (row.itemHasSeveralLines ? ' To count more for it, use the move icon.' : '');
  }
  if (row.value < row.posted) {
    return `${qty(row.posted)} ${row.unit} already posted — it can’t go below ${qty(row.posted)}.`;
  }
  return null;
}
